export default {"src":"/_next/static/media/ClosureZone.041dae1a.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};